import { useExtendedSearchInfiniteQuery } from "src/api/client/extended-search.api";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";

export const useSearchResultCount = (searchParams: ISearchRequestParamsOmitCountry | null) => {
    const { data, isFetching } = useExtendedSearchInfiniteQuery(searchParams, {
        notifyOnChangeProps: ["data", "isFetching"],
        keepPreviousData: true,
    });

    const resultCount = data?.pages[0]?.totalResults ?? null;

    return { resultCount, isFetching };
};
